import styled from "@xstyled/styled-components";

import { modularScale } from "@otta/design-tokens";

export const PageWrapper = styled.section`
  margin: 0;
  padding-bottom: ${modularScale(8)};
`;
